var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9287 11.5563V7.82113H10.8615V11.5563H2.32396V3.01879H6.05912V1.9516H2.32396C1.73457 1.9516 1.25677 2.4294 1.25677 3.01879V11.5563C1.25677 12.1457 1.73457 12.6235 2.32396 12.6235H10.8615C11.4509 12.6235 11.9287 12.1457 11.9287 11.5563ZM10.4229 2.33761C10.1783 2.09109 9.84341 1.9516 9.49405 1.9516C9.14508 1.9516 8.81054 2.09078 8.56455 2.33826L4.09896 6.80379C3.69992 7.15538 3.43834 7.67857 3.39288 8.24123L3.39115 9.95675V10.4903H5.59735C6.2026 10.4488 6.73093 10.1847 7.10363 9.75474L11.5439 5.31635C11.7903 5.07001 11.9287 4.73589 11.9287 4.3875C11.9287 4.03911 11.7903 3.70499 11.5439 3.45864L10.4229 2.33761ZM5.55967 9.42449C5.84472 9.40431 6.11007 9.27164 6.32314 9.02792L9.55773 5.79332L8.08807 4.32356L4.82977 7.58079C4.61359 7.772 4.47985 8.03949 4.45834 8.2842V9.42348L5.55967 9.42449ZM8.84281 3.56907L10.3123 5.03871L10.7893 4.56174C10.8355 4.51553 10.8615 4.45285 10.8615 4.3875C10.8615 4.32214 10.8355 4.25947 10.7893 4.21326L9.66681 3.09075C9.62112 3.04469 9.55893 3.01879 9.49405 3.01879C9.42917 3.01879 9.36698 3.04469 9.32128 3.09075L8.84281 3.56907Z",
    fill: "#2C7465"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEdit);
export default __webpack_public_path__ + "static/media/pencil-edit.1c533d496454968e31d2e3a7afd8c5bf.svg";
export { ForwardRef as ReactComponent };